<template>
    <div class="relative flex flex-col gap-2">
        <label v-if="label">{{ label }}</label>
        <Password v-model="modelValue"
                  :feedback="false"
                  inputClass="w-full"
                  toggleMask
                  :disabled="disabled"
                  :size="size"
        />
    </div>
</template>
<script setup lang="ts">
    // Imports
    import Password from 'primevue/password';

    // Props
    withDefaults(defineProps<{
        label: string,
        disabled?: boolean,
        size?: 'small' | 'large'
    }>(), {
        size: 'small'
    });

    // Refs
    const modelValue = defineModel<string>();
</script>